/**
 * @fileoverview Input/output schemas for world-species-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world species' details.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.activeWorldSpecies.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

export const WorldSpeciesDetailsIdeaSchema = z.object({
  title: z.string().describe('A short, evocative title for this creative direction.'),
  summary: z.string().describe("A detailed summary of the species' biology, behavior, ecological role, and narrative significance."),
});

export type WorldSpeciesDetailsIdea = z.infer<typeof WorldSpeciesDetailsIdeaSchema>;

export const OutputSchema = z.object({
  ideas: z.array(WorldSpeciesDetailsIdeaSchema).length(3).describe('An array of exactly three distinct species detail concepts.'),
});

export type Output = z.infer<typeof OutputSchema>;
